import { Typography, Box, Skeleton, Link } from "@mui/material";
import { useState } from "react";
import Page from "../component/Page";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import PlaceIcon from "@mui/icons-material/Place";
import { DataRequestLink } from "../component/Utils/utils";

const ContactBox = ({ title, content, icon }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: 1,
        textAlign: { xs: "center", sm: "left" },
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Box
        sx={{
          borderRadius: "50%",
          background: "#cf152d",
          height: 50,
          width: 50,
          display: "flex",
          alignItems: "center",
          color: "#FEFEFE",
          justifyContent: "center",
          mx: 2,
          p: 2,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{content}</Typography>
      </Box>
    </Box>
  );
};

export default function Hydrology() {
  const [isMapLoading, setIsMapLoading] = useState(true);
  return (
    <Page>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          my: 10,
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ p: 5, minWidth: 300, maxWidth: 800 }}>
            <Typography variant="h4">Contact Us</Typography>
            <Typography sx={{ textAlign: "justify" }}>
              The Kentucky Climate Center also maintains an archive of
              historical climate data and documents in various forms. We also
              have access to online climate databases and can help find the
              information you need. Simple requests may be filled by telephone,
              or use our <Link href={DataRequestLink}>Request Form</Link>.
            </Typography>
            <Box sx={{ py: 1 }}>
              <ContactBox
                icon={<PhoneIcon />}
                title="Phone"
                content="(270) 745-4567"
              ></ContactBox>
              <ContactBox
                icon={<EmailIcon />}
                title="Email"
                content="kyclimate@wku.edu"
              ></ContactBox>
              <ContactBox
                icon={<PlaceIcon />}
                title="Address"
                content="2413 Nashville Rd., Suite 301, Bowling Green, KY 42101"
              ></ContactBox>
            </Box>
          </Box>
        </Box>
        <Box sx={{ flex: 1, minWidth: 300 }}>
          <Skeleton
            variant="rectangular"
            sx={{
              height: 450,
              width: "100%",
              display: isMapLoading ? "block" : "none",
            }}
          ></Skeleton>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4117.852078483222!2d-86.47129819999999!3d36.961708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8865e917253e27d3%3A0xab28c30841640300!2s2413%20Nashville%20Rd%20Suite%20301%2C%20Bowling%20Green%2C%20KY%2042101%2C%20USA!5e1!3m2!1sen!2suk!4v1738945026746!5m2!1sen!2suk"
            width="600"
            height="450"
            onLoad={() => setIsMapLoading(false)}
            style={{
              border: 0,
              minHeight: 300,
              width: "100%",
              opacity: isMapLoading ? "0" : "1",
              position: isMapLoading ? "absolute" : "static",
            }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>
      </Box>
    </Page>
  );
}
